<template>
    <v-dialog width="400px" v-model="$store.state.showColInfo">
        <v-card v-if="$store.state.showColInfo">
          <v-card-title>
                    <v-icon left>mdi-information-outline</v-icon>
                    {{colInfoText}}
          </v-card-title>

            <v-card-text>
                <div class="pa-3" v-html="$store.getters.colInfo.descr"></div>

            </v-card-text>
          <v-card-actions>
                <v-btn text @click="close()">
                    {{ $t('common.close') }}
                </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script>
    import configs from "../../appConfigs"

    export default {
        name: "ColInfoDialog",
        props: [],
        data() {
            return {
            }
        },
        methods: {
            close(){
                this.$store.commit("clearColInfo")
            },
        },
        computed: {
            colInfoText() {
                const info = this.$store.getters.colInfo
                if (!info) return ''
                const map = {
                    publisher_journal: 'columns.publisher',
                    publisher_short: 'columns.publisherShort',
                    cpu: 'columns.costPerUse',
                    cpu_rank: 'columns.rankByCPU',
                    cost: 'columns.cost',
                    usage: 'columns.usage',
                    instant_usage_percent: 'columns.instantUsagePercent',
                    free_instant_usage_percent: 'columns.freeInstantUsagePercent',
                    subscription_cost: 'columns.subscriptionCost',
                    ill_cost: 'columns.illCost',
                    subscription_minus_ill_cost: 'columns.subscriptionMinusIll',
                    downloads: 'columns.downloads',
                    citations: 'columns.citations',
                    authorships: 'columns.authorships',
                    perpetual_access_years_text: 'columns.pta',
                    baseline_access_text: 'columns.baselineAccess',
                }
                const key = map[info.value]
                return key ? this.$t(key) : info.text
            },
        }
    }
</script>

<style scoped>

</style>